import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// attach admin token
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('cb_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const fetchProducts = (params = {}) => client.get('/products', { params }).then((r) => r.data);
export const fetchProduct = (id) => client.get(`/products/${id}`).then((r) => r.data);
export const fetchReviews = () => client.get('/reviews').then((r) => r.data);
export const submitReview = (data) => client.post('/reviews', data).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post('/newsletter', { email }).then((r) => r.data);
export const sendContact = (data) => client.post('/contact', data).then((r) => r.data);
export const createOrder = (data) => client.post('/orders', data).then((r) => r.data);

// Admin
export const adminLogin = (username, password) => client.post('/admin/login', { username, password }).then((r) => r.data);
export const adminMe = () => client.get('/admin/me').then((r) => r.data);
export const createProduct = (data) => client.post('/products', data).then((r) => r.data);
export const updateProduct = (id, data) => client.put(`/products/${id}`, data).then((r) => r.data);
export const deleteProduct = (id) => client.delete(`/products/${id}`).then((r) => r.data);
export const adminNewsletter = () => client.get('/admin/newsletter').then((r) => r.data);
export const adminOrders = () => client.get('/admin/orders').then((r) => r.data);
export const adminContact = () => client.get('/admin/contact').then((r) => r.data);
export const adminReviews = () => client.get('/admin/reviews').then((r) => r.data);
export const deleteReview = (id) => client.delete(`/reviews/${id}`).then((r) => r.data);

export default client;
